import React, { useEffect, useState } from 'react'
import { useApp } from '../../context/AppContext'
import { supabase } from '../../lib/supabase'
import './Journal.css'

const PROMPTS_ZILNICE = [
  "Cum te simti azi? Ce te-a ajutat sa rezisti?",
  "Ce moment dificil ai depasit azi?",
  "Ce ai facut in loc sa joci?",
  "Cum te simti cand te gandesti la banii economisiti?",
  "Ce ti-a dat forta sa continui programul?",
  "Descrie cel mai greu moment de azi si cum l-ai gestionat.",
  "Ce ai invatat despre tine azi?",
]

const MOODS = [
  { emoji: '😔', label: 'Greu' },
  { emoji: '😐', label: 'Ok' },
  { emoji: '🙂', label: 'Bine' },
  { emoji: '😊', label: 'Foarte bine' },
  { emoji: '🌟', label: 'Excelent' },
]

export default function Journal() {
  const { user } = useApp()
  const [text, setText] = useState('')
  const [mood, setMood] = useState(null)
  const [salvat, setSalvat] = useState(false)
  const [intrari, setIntrari] = useState([])
  const [expandat, setExpandat] = useState(null)
  const [loading, setLoading] = useState(true)

  const today = new Date().toISOString().split('T')[0]
  const promptZilnic = PROMPTS_ZILNICE[new Date().getDay()]

  useEffect(() => { loadIntrari() }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function loadIntrari() {
    const { data } = await supabase
      .from('progres_zilnic').select('data, jurnal_text, jurnal_mood')
      .eq('user_id', user.id)
      .not('jurnal_text', 'is', null)
      .order('data', { ascending: false })
      .limit(20)
    if (data) setIntrari(data.filter(d => d.jurnal_text))
    setLoading(false)

    const azi = data?.find(d => d.data === today)
    if (azi?.jurnal_text) { setText(azi.jurnal_text); setMood(azi.jurnal_mood) }
  }

  async function salveaza() {
    if (!text.trim()) return
    await supabase.from('progres_zilnic').upsert({
      user_id: user.id, data: today,
      jurnal_text: text, jurnal_mood: mood,
    })
    setSalvat(true)
    setTimeout(() => setSalvat(false), 2000)
    loadIntrari()
  }

  if (loading) return <div className="loading-screen">Se incarca jurnalul...</div>

  return (
    <div className="journal-page">
      <div className="journal-header">
        <h1>Jurnalul tau</h1>
        <div className="journal-date">{new Date().toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
      </div>

      <div className="journal-today">
        <div className="journal-prompt">
          <span className="prompt-icon">✍️</span>
          {promptZilnic}
        </div>

        <div className="mood-row">
          <span className="mood-label">Cum te simti azi?</span>
          <div className="mood-options">
            {MOODS.map((m, i) => (
              <button key={i} className={`mood-btn ${mood === i ? 'selected' : ''}`} onClick={() => setMood(i)} title={m.label}>
                {m.emoji}
              </button>
            ))}
          </div>
        </div>

        <textarea
          className="journal-textarea"
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Scrie liber despre ziua ta..."
          rows={6}
        />

        <div className="journal-actions">
          <span className="char-count">{text.length} caractere</span>
          <button className={`btn-primary ${salvat ? 'btn-saved' : ''}`} onClick={salveaza} disabled={!text.trim()}>
            {salvat ? '✓ Salvat!' : 'Salveaza'}
          </button>
        </div>
      </div>

      <div className="journal-history">
        <h2>Intrari anterioare</h2>
        {intrari.length === 0 ? (
          <div className="journal-empty">Nu ai intrari anterioare. Scrie primul tau jurnal azi!</div>
        ) : (
          intrari.map((intrare, i) => (
            <div key={i} className="journal-entry" onClick={() => setExpandat(expandat === i ? null : i)}>
              <div className="entry-header">
                <div className="entry-date">
                  {new Date(intrare.data + 'T12:00:00').toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long' })}
                </div>
                <div className="entry-right">
                  {intrare.jurnal_mood !== null && <span className="entry-mood">{MOODS[intrare.jurnal_mood]?.emoji}</span>}
                  <span className="entry-arrow">{expandat === i ? '▲' : '▼'}</span>
                </div>
              </div>
              {expandat === i ? (
                <div className="entry-text-full">{intrare.jurnal_text}</div>
              ) : (
                <div className="entry-preview">{intrare.jurnal_text.substring(0, 100)}{intrare.jurnal_text.length > 100 ? '...' : ''}</div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
